import { render, staticRenderFns } from "./ShareLinks.vue?vue&type=template&id=a3e00c4a&scoped=true"
import script from "./ShareLinks.vue?vue&type=script&lang=js"
export * from "./ShareLinks.vue?vue&type=script&lang=js"
import style0 from "./ShareLinks.vue?vue&type=style&index=0&id=a3e00c4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e00c4a",
  null
  
)

export default component.exports